import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}


internals.getReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  }
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`;
  }
  if(params.zone){   
    parameters += `&wardIds=${params.zone}`;
  } 
  return http
    .get(`/trip/reports/ward-collection-report/list${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
},

internals.getTripReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  }
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`;
  }


  return http
    .get(`/trip/reports/vehicle-report/list${parameters}`)
    .then(response => {     
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
},

internals.getWardReport = params =>{
    let parameters=`wardId=${params.wardId}&startDate=${params.date}&type=${params.type}`
    return http
      .get(`trip/reports/ward-collection-report/download?${parameters}`)
      .then(response => {      
        return response
      })
      .catch(error => {
        console.error('reportsService-error:\n', error)
        throw error
      })
},


internals.getTripReport = params =>{
  let parameters=`vehicleId=${params.vehicleId}&startDate=${params.startDate}&endDate=${params.endDate}`
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`;
  }
  return http
    .get(`trip/reports/vehicle-report/download?${parameters}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('reportsService-error:\n', error)
      throw error
    })
},
internals.getCityCollectionReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  } 

  return http
    .get(`/trip/reports/city-report/list${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
},

// &endDate=${params.endDate}
internals.getCityCollectionReport = params =>{
  let parameters=`cityId=${params.cityId}&startDate=${params.startDate}&type=${params.type}`
  return http
    .get(`/trip/reports/city-collection-report/download?${parameters}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('reportsService-error:\n', error)
      throw error
    })
},

internals.getLineCollectionReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
    
  }
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  } 

  return http
    .get(`/trip/reports/line-report/list${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
}, internals.getDailyCityCollectionReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  } 

  return http
    .get(`/trip/primary-trip/reports/all-work-done-report-primaryTrip/list${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
},
internals.getLineCollectionReport = params =>{
  let parameters=`cityId=${params.cityId}&startDate=${params.startDate}&type=${params.type}`
  return http
    .get(`/trip/reports/Line-collection-report/download?${parameters}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('reportsService-error:\n', error)
      throw error
    })
},
internals.getMonthlyCityCollectionReportList = params =>{
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  } 
  if(params.cityId){
    parameters += `&cityId=${params.cityId}`;
  }

  return http
    .get(`/trip/reports/city-monthly-collection-report/list${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('reportService-error:\n', error)
      throw error
    })
},
internals.getMonthlyCityCollectionReport = params =>{
  let parameters=`cityId=${params.cityId}&startDate=${params.startDate}&type=${params.type}`
  return http
    .get(`/trip/reports/city-monthly-collection-report/download?${parameters}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('reportsService-error:\n', error)
      throw error
    })
  },
  internals.getDailyCityCollectionReport = params =>{
    let parameters=`date=${params.startDate}&cityId=${params.cityId}&type=${params.type}`
    return http
    .get(`/trip/primary-trip/reports/work-done-report-primaryTrip/download?${parameters}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('reportsService-error:\n', error)
      throw error
    })
  }


export default internals;




// WEBPACK FOOTER //
// ./src/services/reports.service.js